export default __webpack_public_path__ + "static/media/english-to-russian-screenshot-04.7aa96ad8.png";